<template>
	<b-card class="border-0 bg-light">
        <slot />
	</b-card>
</template>

<script>
export default {
    
}
</script>